import { EXTERNAL_SHARE } from '@confluence/named-routes/entry-points/routes.ts';

export const isExternalShareRequest = () => !!EXTERNAL_SHARE.match(window.location.pathname);
